import { HTMLProps } from 'react';

import { cm } from '../../libs/cm';

type LeftBorderContainerProps = {
  borderColor?: string;
  maxWidth?: string;
} & HTMLProps<HTMLDivElement>;

export const LeftBorderContainer = ({
  children,
  borderColor = '#D4DCEB',
  maxWidth,
  className,
  ...rest
}: LeftBorderContainerProps) => {
  const classes = cm(
    `tw-flex tw-bg-white tw-w-full ${
      maxWidth ? maxWidth : ''
    } tw-shadow-sula tw-rounded-3xl`,
    className
  );

  return (
    <div className={classes} {...rest}>
      <div
        className={`tw-border-r-[1.3125rem] tw-rounded-l-3xl tw-min-h-full tw-bg-[#D4DCEB}]`}
        style={{ borderColor: borderColor }}
      />
      {/* tw-justify-around */}
      <div className="tw-flex tw-flex-col tw-items-center tw-flex-1 tw-py-[20px] tw-relative">
        {children}
      </div>
    </div>
  );
};
